export const DPS_ADMINISTRATION_PHONE_NUMBER = '051 46 58 16';
export const DPS_ADMINISTRATION_EMAIL = 'support@staffler.be';

export const DPS_FINANCE_PHONE_NUMBER = '09 210 09 14';
